import { Avatar } from '@material-ui/core'
import React, {useEffect} from 'react'
import './SingleMessage.css'
import {useHistory} from 'react-router-dom'
import {db} from '../../Firebase/firebase'
import { useStore } from '../../StateManagement';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';

function SingleMessage({read, imageUrl, name, message, id, lastPerson}) {
  let history = useHistory();
  const [stateData, dispatch] = useStore();

  return (
      <div className="single__message" onClick={()=> history.push(`/chats/group/${id}`)}>
        <div className="single__message__container">
          <Avatar src={imageUrl} className="avatar" />
          <div className="info">
            <h1 className={`room__name ${read &&"room__name__seen"}`}>
              {name}
            </h1>
            <div className="sender__info">
              {lastPerson && <span>{lastPerson === stateData.userDetails.name ? 'you:' : `${lastPerson}:`}</span>}
              <p>{message}</p>
            </div>
          </div>
          <div className="extra__info">
            <p className="time">8:30am</p>
            <div className="extra__info__flex">
              <span>1</span>
              <KeyboardArrowDownIcon />
            </div>
          </div>
        </div>
      </div>
  )
}

export default SingleMessage
